import styled from 'styled-components';

const SectionLinksWrapper = styled.div`
  display: flex;
  align-content: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
`;

export default SectionLinksWrapper;
